import styled from '@emotion/styled';
import { CheckIcon } from 'src/assets/icons/CheckIcon';
import { CloseIcon } from 'src/assets/icons/CloseIcon';
import { srgQuestions } from 'src/assets/colors';

export const SrgQuestionnaireInfo = styled('h3', { label: 'SrgQuestionnaireInfo' })`
    font-size: 16px;
    font-weight: 600;
    margin: 4px 0 4px 0;
    line-height: 32px;
`;

export const SrgQuestionnaireContainer = styled('div', { label: 'SrgQuestionnaireContainer' })`
    border: 4px solid ${srgQuestions.borderColor};
    margin: 8px 0 24px 0;
`;

export const SrgQuestionnaireItem = styled('div', { label: 'SrgQuestionnaireItem' })`
    padding: 8px 12px;
    border-bottom: 4px solid ${srgQuestions.borderColor};
    font-size: 12px;
    display: flex;

    &:last-of-type {
        border: none;
        padding-bottom: 0;
    }
`;

export const SrgQuestionnaireItemsWrapper = styled('div', { label: 'SrgQuestionnaireItemsWrapper' })`
    margin-bottom: 8px;
`;

export const SrgQuestionnaireItemCounter = styled('span', { label: 'SrgQuestionnaireItemCounter' })`
    width: 40px;
    color: rgba(0, 0, 0, 0.24);
    font-weight: 600;
`;

export const SrgQuestionnaireItemText = styled('p', { label: 'SrgQuestionnaireItemText' })`
    margin: 0 0 0 16px;
`;

export const SrgQuestionnaireButtons = styled('div', { label: 'SrgQuestionnaireButtons' })`
    display: flex;
    justify-content: space-between;
`;

export const SrgQuestionnaireItemRadioButtons = styled('div', { label: 'SrgQuestionnaireItemRadioButtons' })`
    margin-left: auto;
    display: flex;
`;

export const CheckIconWrapper = styled(CheckIcon, { label: 'CheckIconWrapper' })`
    fill: ${srgQuestions.checkIconColor};

    margin-left: 10px;
    width: 15px;
`;


export const WrongIconWrapper = styled(CloseIcon, { label: 'WrongIconWrapper' })`
    fill: ${srgQuestions.wrongIconColor};
    margin-left: 10px;
    width: 15px;
`;

interface SrgStatusType {
    isPassed: boolean
}

export const SrgStatus = styled('span', { label: 'SrgStatus' }) <SrgStatusType>`
    color: ${({ isPassed }): string => isPassed ? srgQuestions.checkIconColor : srgQuestions.wrongIconColor};
`;
